/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_TitleInputs */

const en_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Advanced Features`)
};

const ar_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميزات متقدمة إضافية`)
};

const de_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Erweiterte Funktionen`)
};

const es_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones avanzadas de Plus`)
};

const fr_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités Avancées Plus`)
};

const it_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità Plus Avanzate`)
};

const ja_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusの高度な機能`)
};

const ko_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 고급 기능`)
};

const pt_br_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades avançadas Plus`)
};

const ru_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продвинутые Plus-функции`)
};

const th_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมบัติขั้นสูงของ Plus`)
};

const tr_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Gelişmiş Özellikler`)
};

const zh_cn_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 进阶功能`)
};

const zh_tw_subscription_exclusive_feature_title = /** @type {(inputs: Subscription_Exclusive_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 進階功能`)
};

/**
* | output |
* | --- |
* | "Plus Advanced Features" |
*
* @param {Subscription_Exclusive_Feature_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_title = /** @type {((inputs?: Subscription_Exclusive_Feature_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_title(inputs)
	return zh_tw_subscription_exclusive_feature_title(inputs)
});